var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-unused-vars */
import { Divider } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { isIOption } from '../types/commonTypes';
import { Column } from './components/Column';
import { CustomHelperText, FieldWrapper, Wrapper, } from './DuoColumnSelector.Styles';
export var DuoColumnSelector = function (props) {
    var _a = [
        props.values || props.field.value || [],
        function (val) {
            return props.form.setFieldValue(props.field.name, val);
        },
    ], values = _a[0], setValues = _a[1];
    var _b = useState(props.itemOptions), options = _b[0], setOptions = _b[1];
    var _c = React.useState({}), updateState = _c[1];
    var forceUpdate = React.useCallback(function () { return updateState({}); }, []);
    var fieldTouched = function () { return props.form.setFieldTouched(props.field.name, true); };
    useEffect(function () {
        if (props.doValueChange) {
            setOptions(props.itemOptions);
            setValues([]);
        }
        else {
            var _values = __spreadArrays(values);
            var _options_1 = __spreadArrays(props.itemOptions);
            _values.forEach(function (values_) {
                var op = _options_1.find(function (o) {
                    return isIOption(o) && isIOption(values_)
                        ? o.value === values_.value
                        : o === values_;
                });
                var index = _options_1.indexOf(op);
                _options_1.splice(index, 1);
            });
            setOptions(_options_1);
        }
    }, [props.dependency]);
    useEffect(function () {
        var _values = __spreadArrays(values);
        var _options = __spreadArrays(props.itemOptions);
        _values.forEach(function (values_) {
            var op = _options.find(function (o) {
                return isIOption(o) && isIOption(values_)
                    ? o.value === values_.value
                    : o === values_;
            });
            var index = _options.indexOf(op);
            _options.splice(index, 1);
        });
        _options.sort(function (x, z) {
            return options.indexOf(x) - options.indexOf(z);
        });
        setOptions(_options);
    }, [values]);
    var handleChange = function (values) {
        props.onChange && props.onChange(values);
    };
    var getEquivalentValue = function (valOp, draggableId) {
        var val = isIOption(valOp[0])
            ? valOp.find(function (item) { return item.value === draggableId; }) ||
                draggableId
            : draggableId;
        return val;
    };
    var onDragEnd = function (result) {
        var destination = result.destination, source = result.source, draggableId = result.draggableId;
        var val;
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId &&
            destination.index === source.index) {
            return;
        }
        if (destination.droppableId === source.droppableId) {
            var column = [];
            if (destination.droppableId === 'active') {
                val = getEquivalentValue(values, draggableId);
                column = __spreadArrays(values);
                column.splice(source.index, 1);
                column.splice(destination.index, 0, val);
                setValues(column);
                handleChange(column);
            }
            else {
                val = getEquivalentValue(options, draggableId);
                column = __spreadArrays(options);
                column.splice(source.index, 1);
                column.splice(destination.index, 0, val);
                setOptions(column);
            }
        }
        else if (destination.droppableId !== source.droppableId) {
            var column1 = values;
            var column2 = options;
            if (destination.droppableId === 'active') {
                val = getEquivalentValue(column2, draggableId);
                column2.splice(source.index, 1);
                column1.splice(destination.index, 0, val);
            }
            else {
                val = getEquivalentValue(column1, draggableId);
                column1.splice(source.index, 1);
                column2.splice(destination.index, 0, val);
            }
            setValues(column1);
            setOptions(column2);
            handleChange(column1);
        }
        fieldTouched();
    };
    var onItemClick = function (droppableId, draggableId, index) {
        var column1 = values;
        var column2 = options;
        var val = isIOption(props.itemOptions[0])
            ? props.itemOptions.find(function (item) { return item.value === draggableId; }) || draggableId
            : draggableId;
        if (droppableId === 'active') {
            column1.splice(index, 1);
            // column2.splice(0, 0, draggableId);
            column2.push(val);
        }
        else {
            column2.splice(index, 1);
            // column1.splice(0, 0, draggableId);
            column1.push(val);
        }
        setValues(column1);
        setOptions(column2);
        forceUpdate();
        fieldTouched();
        handleChange(column1);
    };
    var willError = props.form.touched[props.field.name] &&
        !!props.form.errors[props.field.name];
    var reverseArr = function (input) {
        var ret = new Array();
        for (var i = input.length - 1; i >= 0; i--) {
            ret.push(input[i]);
        }
        return ret;
    };
    var sortArr = function (input) {
        var ret = Array.from(input);
        if (isIOption(ret[0])) {
            ret.sort(function (a, b) {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            });
        }
        else {
            ret.sort(function (a, b) {
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
            });
        }
        return ret;
    };
    return (React.createElement(FieldWrapper, { className: 'DuoColumnSelector' },
        React.createElement(CustomHelperText, null, props.label),
        React.createElement(DragDropContext, { onDragEnd: onDragEnd },
            React.createElement(Wrapper, null,
                React.createElement(Column, { items: values, columnName: 'Active', columnID: 'active', onItemClick: function (droppableId, draggableId, index) {
                        return onItemClick(droppableId, draggableId, index);
                    }, onReverse: function () {
                        setValues(reverseArr(values));
                        handleChange(reverseArr(values));
                    }, onSort: function () {
                        setValues(sortArr(values));
                        handleChange(sortArr(values));
                    } }),
                React.createElement(Divider, { orientation: 'vertical' }),
                React.createElement(Column, { items: options, columnName: 'Inactive', columnID: 'inActive', onItemClick: function (droppableId, draggableId, index) {
                        return onItemClick(droppableId, draggableId, index);
                    }, onReverse: function () { return setOptions(reverseArr(options)); }, onSort: function () {
                        setOptions(sortArr(options));
                    } }))),
        willError && (React.createElement(CustomHelperText, { error: willError }, props.form.errors[props.field.name]))));
};
DuoColumnSelector.defaultProps = {
    doValueChange: true
};
//# sourceMappingURL=DuoColumnSelector.js.map